import { GetVenueType as ApiVenueDetailsType } from 'src/api/generated/touring/types';
import { mapAddress } from '../common';
import { mapCoordinates, mapVenueOperator } from './helpers';
import { VenueDetailsType } from './types';

export const mapVenueDetailsType = (
  apiVenue: ApiVenueDetailsType
): VenueDetailsType => {
  return {
    type: 'VENUE',
    id: apiVenue.id,
    name: apiVenue.name,
    shortName: apiVenue.shortName,
    category: apiVenue.category,
    website: apiVenue.website,
    venuePromoterId: apiVenue.venuePromoterId,
    address: mapAddress(apiVenue.address),
    coordinates: apiVenue.coordinates
      ? mapCoordinates(apiVenue.coordinates)
      : null,
    venueOperator: apiVenue.venueOperator
      ? mapVenueOperator(apiVenue.venueOperator)
      : null,
  };
};
